import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * Scheduled social content for the content calendar.
 */
@Entity('recon_scheduled_content')
@Index('idx_recon_scheduled_status', ['status', 'scheduledFor'])
export class ReconScheduledContentEntity extends BaseEntity {
	// Content
	@Column('varchar', { name: 'platform', length: 50 })
	public platform!: string;

	/**
	 * Content type.
	 * 'post', 'share', 'thread'
	 */
	@Column('varchar', { name: 'content_type', length: 50 })
	public contentType!: string;

	@Column('text', { name: 'content' })
	public content!: string;

	@Column('json', { name: 'media_urls', nullable: true })
	public mediaUrls!: string[] | null;

	// Scheduling
	@Column('datetime', { name: 'scheduled_for' })
	public scheduledFor!: Date;

	@Column('varchar', { name: 'timezone', length: 50 })
	public timezone!: string;

	// State
	/**
	 * Publishing status.
	 * 'scheduled', 'published', 'failed', 'cancelled'
	 */
	@Column('varchar', { name: 'status', length: 30, default: 'scheduled' })
	public status!: string;

	@Column('datetime', { name: 'published_at', nullable: true })
	public publishedAt!: Date | null;

	@Column('varchar', { name: 'platform_post_id', length: 500, nullable: true })
	public platformPostId!: string | null;

	@Column('text', { name: 'publish_error', nullable: true })
	public publishError!: string | null;
}
